module.exports = __webpack_public_path__ + "static/media/tdd.7c3112a5.png";